import { RunModel } from "models/RunModel";
import { createContext } from "react";

export interface IRunContext {
  runId: string | undefined;
  run: RunModel | undefined;
  isLoading: boolean;
  isCurrentUserParticipant: boolean;
  isPublished: boolean;
  isPreparing: boolean;
  isClosed: boolean;
  reloadRun: () => Promise<void>;
}

export const RunContext = createContext({} as IRunContext);

/** @deprecated Use IRunContext */
export type IRunProviderContext = IRunContext;
